import { motion } from "framer-motion";
import { MapPin, Phone, Clock, MessageCircle } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

export default function Contacts() {
  return (
    <section id="contatti" data-testid="contacts-section" className="relative py-28 sm:py-40 bg-coal border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6">
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: EASE }}
          className="text-[11px] tracking-[0.45em] uppercase text-terra"
        >
          Contatti & Dove Siamo
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, delay: 0.1, ease: EASE }}
          className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-cream mt-4"
        >
          Ti aspettiamo <span className="italic text-gold">questa sera.</span>
        </motion.h2>

        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 mt-16 items-stretch">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, ease: EASE }}
            className="flex flex-col gap-10 justify-center"
          >
            <div data-testid="info-address" className="flex gap-4">
              <MapPin size={22} strokeWidth={1.4} className="text-terra shrink-0 mt-1" />
              <div>
                <h3 className="font-display text-2xl text-cream">Dove siamo</h3>
                <p className="text-cream/55 text-sm sm:text-base mt-2 leading-relaxed">
                  Via Guglielmo Marconi, 48<br />95013 Fiumefreddo di Sicilia (CT)
                </p>
              </div>
            </div>
            <div data-testid="info-hours" className="flex gap-4">
              <Clock size={22} strokeWidth={1.4} className="text-terra shrink-0 mt-1" />
              <div>
                <h3 className="font-display text-2xl text-cream">Orari</h3>
                <p className="text-cream/55 text-sm sm:text-base mt-2 leading-relaxed">
                  Aperti 7 giorni su 7, servizio serale<br />dalle 19:00
                </p>
              </div>
            </div>
            <div data-testid="info-phone" className="flex gap-4">
              <Phone size={22} strokeWidth={1.4} className="text-terra shrink-0 mt-1" />
              <div>
                <h3 className="font-display text-2xl text-cream">Telefono & Ordini</h3>
                <a href="tel:+393892472195" className="text-cream/55 text-sm sm:text-base mt-2 block hover:text-gold transition-colors duration-300">
                  +39 389 247 2195
                </a>
                <p className="text-cream/40 text-xs tracking-[0.15em] uppercase mt-2">
                  Asporto e domicilio · € 0,50 a pizza
                </p>
              </div>
            </div>
            <a
              data-testid="whatsapp-btn"
              href="https://wa.me/393892472195"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-terra text-cream text-xs tracking-[0.25em] uppercase px-8 py-4 w-fit hover:bg-cream hover:text-ink transition-colors duration-300"
            >
              <MessageCircle size={15} strokeWidth={1.5} />
              Ordina su WhatsApp
            </a>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 1, delay: 0.15, ease: EASE }}
            className="border border-white/10 overflow-hidden min-h-[380px]"
          >
            <iframe
              data-testid="map-iframe"
              title="Mappa Pizzeria Grano"
              src="https://www.google.com/maps?q=Pizzeria%20Grano%2C%20Via%20Guglielmo%20Marconi%2048%2C%20Fiumefreddo%20di%20Sicilia&output=embed"
              className="w-full h-full min-h-[380px] map-frame"
              loading="lazy"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
